import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../utils/decorators";
import * as Cookies from 'js-cookie';


@Options({
    template: false,
    ui: {}
})

export default class BlogCTA extends Marionette.View<Backbone.Model>{
    config?: object;
    cta?: any;

    constructor(options?: object, config?: object) {
        super(options);
        this.config = config || {};

        this.cta = this.$el[0];
    }

    onRender() {
        let onScroll = () => {
            if(window.pageYOffset > 300) {
                this.cta.classList.add('visible');
                document.querySelector('body').classList.add('blog-cta-visible');
                document.removeEventListener('scroll', onScroll);
            }
        }

        document.addEventListener('scroll', onScroll);

        this.cta.querySelector('.blog-cta__close').addEventListener('click', () => {
            this.cta.classList.remove('visible');
            document.querySelector('body').classList.remove('blog-cta-visible');
        });
    }
}




// WEBPACK FOOTER //
// ./@modules/views/blog-cta.ts